import React from 'react';
import { aboutContent, founderStory } from '../mock';
import { Cross, Shield, Users, Book, Heart } from 'lucide-react';

const getValueIcon = (title) => {
  if (title.includes('Christ-Centered')) return <Cross size={24} />;
  if (title.includes('Healing')) return <Shield size={24} />;
  if (title.includes('Community')) return <Users size={24} />;
  if (title.includes('Truth')) return <Book size={24} />;
  return <Cross size={24} />;
};

export const About = () => {
  return (
    <section id="about" className="section-padding" style={{ 
      background: 'linear-gradient(135deg, #FFF8DC 0%, #F5F5DC 100%)',
      position: 'relative'
    }}>
      <div className="container">
        {/* Ministry Mission Section */}
        <div className="grid-two-column" style={{ marginBottom: '120px' }}>
          <div>
            <h2 className="hero-medium" style={{ marginBottom: '32px', color: '#8B4513' }}>
              Our Heart & Mission
            </h2>
            
            <p className="body-large" style={{ marginBottom: '32px', color: '#5D4037', lineHeight: '1.7' }}>
              Khesed+ exists to help those experiencing brokenness rebuild their lives on a firm foundation in Jesus Christ. 
              We equip people with a ready-to-use toolbox of biblical truth, emotional support, accountability, and practical strategies; 
              empowering them to face life's storms with unwavering faith, spiritual strength, and mental resilience. Restoring lives on the Rock.
            </p>
            
            <div style={{ 
              background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.1) 0%, rgba(205, 133, 63, 0.2) 100%)',
              padding: '32px', 
              borderRadius: '0px',
              border: '2px solid #CD853F',
              position: 'relative'
            }}>
              {/* Beautiful praying hands image */}
              <div style={{
                width: '60px',
                height: '60px',
                backgroundImage: 'url(https://images.unsplash.com/photo-1571112058133-056102737cd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxoZWFsaW5nJTIwcHJheWVyfGVufDB8fHx8MTc1NjI2MzY5MHww&ixlib=rb-4.1.0&q=85)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '50%',
                marginBottom: '16px',
                border: '3px solid #8B4513'
              }}></div>
              
              <h3 className="heading-2" style={{ marginBottom: '16px', color: '#8B4513' }}>
                Our Vision
              </h3>
              <p className="body-regular" style={{ color: '#5D4037' }}>
                {aboutContent.vision}
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="heading-2" style={{ marginBottom: '32px', color: '#8B4513' }}>
              Our Values
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {aboutContent.values.map((value, index) => (
                <div key={index} style={{ 
                  display: 'flex', 
                  gap: '16px',
                  padding: '24px',
                  background: 'linear-gradient(135deg, rgba(255, 248, 220, 0.8) 0%, rgba(245, 245, 220, 0.9) 100%)',
                  borderRadius: '0px',
                  border: '1px solid #CD853F',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(139, 69, 19, 0.1)'
                }}>
                  <div style={{ 
                    color: '#8B4513',
                    marginTop: '4px'
                  }}>
                    {getValueIcon(value.title)}
                  </div>
                  
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '8px', color: '#8B4513' }}>
                      {value.title}
                    </h4>
                    <p className="body-regular" style={{ color: '#5D4037' }}>
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Founder's Story Section with beautiful background */}
        <div style={{ 
          background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.05) 0%, rgba(205, 133, 63, 0.1) 100%)',
          padding: '80px 48px',
          borderRadius: '0px',
          marginBottom: '80px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background image for story section */}
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '300px',
            height: '100%',
            backgroundImage: 'url(https://images.unsplash.com/photo-1554355204-50ec66e4a5e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxDaHJpc3RpYW4lMjBtaW5pc3RyeXxlbnwwfHx8fDE3NTYyNjM2ODN8MA&ixlib=rb-4.1.0&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.15,
            zIndex: 1
          }}></div>
          
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              marginBottom: '32px'
            }}>
              <Heart size={28} style={{ color: '#8B4513' }} />
              <h2 className="hero-medium" style={{ color: '#8B4513' }}>My Story</h2>
            </div>
            
            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <p className="body-large" style={{ color: '#2F1B14' }}>
                {founderStory.intro}
              </p>
              
              <p className="body-large" style={{ color: '#5D4037' }}>
                {founderStory.background}
              </p>
              
              <p className="body-large" style={{ color: '#5D4037' }}>
                {founderStory.foundation}
              </p>
              
              <p className="body-large" style={{ color: '#5D4037' }}>
                {founderStory.struggle}
              </p>
              
              <div style={{ 
                background: 'linear-gradient(135deg, rgba(255, 248, 220, 0.9) 0%, rgba(245, 245, 220, 0.9) 100%)',
                padding: '32px', 
                borderRadius: '0px',
                border: '2px solid #8B4513',
                margin: '16px 0',
                boxShadow: '0 8px 24px rgba(139, 69, 19, 0.15)'
              }}>
                <p className="body-large" style={{ color: '#2F1B14', fontWeight: '600' }}>
                  {founderStory.purpose}
                </p>
              </div>
              
              <p className="body-large" style={{ color: '#5D4037' }}>
                {founderStory.refinement}
              </p>
              
              <div style={{ textAlign: 'center', margin: '32px 0' }}>
                <p className="heading-3" style={{ color: '#8B4513', marginBottom: '16px' }}>
                  {founderStory.joy}
                </p>
                <p className="heading-2" style={{ color: '#8B4513' }}>
                  {founderStory.blessing}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Walking Together Section with community image */}
        <div style={{ 
          textAlign: 'center',
          background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.1) 0%, rgba(205, 133, 63, 0.2) 100%)',
          padding: '48px',
          borderRadius: '0px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Community worship background */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '200px',
            height: '100%',
            backgroundImage: 'url(https://images.unsplash.com/flagged/photo-1567116681178-c326fa4e2c8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxDaHJpc3RpYW4lMjBtaW5pc3RyeXxlbnwwfHx8fDE3NTYyNjM2ODN8MA&ixlib=rb-4.1.0&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.2,
            zIndex: 1
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            <h3 className="heading-1" style={{ marginBottom: '24px', color: '#8B4513', textAlign: 'center' }}>
              Walking Together in Faith
            </h3>
            <p className="body-large" style={{ color: '#5D4037', maxWidth: '800px', margin: '0 auto 32px auto', textAlign: 'center' }}>
              We are here to walk with you every step of the way.
            </p>
            
            {/* Bible Verse Box */}
            <div style={{
              background: 'rgba(255, 248, 220, 0.9)',
              border: '2px solid #8B4513',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '600px',
              margin: '0 auto',
              textAlign: 'center'
            }}>
              <h4 style={{ 
                color: '#8B4513', 
                marginBottom: '16px', 
                fontSize: '18px', 
                fontWeight: '600',
                fontFamily: 'Crimson Text, serif'
              }}>
                Hebrews 10:25:
              </h4>
              <p style={{ 
                color: '#5D4037', 
                fontSize: '16px', 
                lineHeight: '1.6',
                fontStyle: 'italic',
                fontFamily: 'Crimson Text, serif',
                margin: '0'
              }}>
                "Not giving up meeting together, as some are in the habit of doing, but encouraging one another—and all the more as you see the Day approaching." (NIV)
              </p>
            </div>
          </div>
        </div>

        {/* See Our Ministry in Action - YouTube Videos Section */}
        <div style={{ 
          background: 'rgba(139, 69, 19, 0.05)',
          border: '2px solid #D2B48C',
          borderRadius: '0px',
          padding: '60px 40px',
          marginTop: '80px'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h3 className="heading-1" style={{ marginBottom: '24px', color: '#8B4513' }}>
              See Our Ministry in Action
            </h3>
            <p className="body-large" style={{ color: '#5D4037', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
              Watch how we're helping women rebuild their lives on the foundation of Christ through practical tools, 
              daily encouragement, and heartfelt prayer.
            </p>
          </div>

          {/* Featured Video - Empowering Women with Transformation Tools */}
          <div style={{ marginBottom: '48px', textAlign: 'center' }}>
            <div style={{
              background: 'rgba(255, 248, 220, 0.8)',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '600px',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              
              {/* YouTube Embed - Empowering Women */}
              <div style={{ 
                width: '100%', 
                maxWidth: '400px', 
                display: 'flex', 
                justifyContent: 'center',
                marginBottom: '20px',
                position: 'relative'
              }}>
                <div style={{ 
                  position: 'relative', 
                  width: '100%', 
                  height: '0', 
                  paddingBottom: '177.78%', // 16:9 aspect ratio for vertical video (9:16 inverted)
                  maxWidth: '325px',
                  margin: '0 auto'
                }}>
                  <iframe
                    src="https://www.youtube.com/embed/ouwOuaOMijM?si=Ao8wWGqh0XaqJGUC"
                    title="Empowering Women with Transformation Tools"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      borderRadius: '8px',
                      border: '2px solid #D2B48C'
                    }}
                  />
                </div>
              </div>
              
              <div style={{ textAlign: 'center', width: '100%' }}>
                <h4 className="heading-3" style={{ marginBottom: '12px', color: '#8B4513' }}>
                  Empowering Women with Transformation Tools
                </h4>
                <p className="body-regular" style={{ color: '#5D4037', marginBottom: '20px' }}>
                  See the impact of our reframing techniques helping hearts heal and lives rebuild.
                </p>
                <button
                  className="btn-primary"
                  onClick={() => window.open('https://calendly.com/khesed-avad', '_blank')}
                  style={{
                    background: '#8B4513',
                    borderColor: '#8B4513',
                    color: 'white',
                    padding: '12px 24px',
                    border: '2px solid #8B4513',
                    borderRadius: '0px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Book Your Free Session
                </button>
              </div>
            </div>

          </div>

          {/* Additional Videos Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            {/* Devotional Video */}
            <div style={{
              background: 'rgba(255, 248, 220, 0.6)',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{ 
                position: 'relative', 
                width: '100%', 
                height: '0', 
                paddingBottom: '177.78%', // 16:9 aspect ratio for vertical video (9:16 inverted)
                maxWidth: '250px',
                margin: '0 auto'
              }}>
                <iframe
                  src="https://www.youtube.com/embed/vv_bix5Pvt8?si=qbXZee2DceOdlw8p"
                  title="Daily Devotionals"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '8px',
                    border: '2px solid #D2B48C'
                  }}
                />
              </div>
              
              <div style={{ marginTop: '16px' }}>
                <h5 className="heading-4" style={{ marginBottom: '8px', color: '#8B4513', fontSize: '16px' }}>
                  Daily Devotionals
                </h5>
                <p className="body-small" style={{ color: '#5D4037', marginBottom: '12px' }}>
                  Experience our daily devotionals bringing hope and healing to your heart.
                </p>
                <button
                  className="btn-secondary"
                  onClick={() => {
                    const element = document.querySelector('#services');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{
                    background: 'transparent',
                    border: '2px solid #CD853F',
                    borderRadius: '0px',
                    color: '#8B4513',
                    padding: '8px 16px',
                    fontSize: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Get Free Devotionals
                </button>
              </div>
            </div>

            {/* Prayer Video */}
            <div style={{
              background: 'rgba(255, 248, 220, 0.6)',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{ 
                position: 'relative', 
                width: '100%', 
                height: '0', 
                paddingBottom: '177.78%', // 16:9 aspect ratio for vertical video (9:16 inverted)
                maxWidth: '250px',
                margin: '0 auto'
              }}>
                <iframe
                  src="https://www.youtube.com/embed/cLFa6fVUxms?si=wwsfQoDW8IbDtDGm"
                  title="Prayer Ministry"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '8px',
                    border: '2px solid #D2B48C'
                  }}
                />
              </div>
              
              <div style={{ marginTop: '16px' }}>
                <h5 className="heading-4" style={{ marginBottom: '8px', color: '#8B4513', fontSize: '16px' }}>
                  Prayer Ministry
                </h5>
                <p className="body-small" style={{ color: '#5D4037', marginBottom: '12px' }}>
                  We stand in the gap in prayer - let us pray with you through your healing journey.
                </p>
                <button
                  className="btn-secondary"
                  onClick={() => {
                    const element = document.querySelector('#contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{
                    background: 'transparent',
                    border: '2px solid #CD853F',
                    borderRadius: '0px',
                    color: '#8B4513',
                    padding: '8px 16px',
                    fontSize: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Request Prayer Support
                </button>
              </div>
            </div>
          </div>

          {/* Follow CTA */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <p className="body-regular" style={{ color: '#5D4037', marginBottom: '16px' }}>
              Follow us for daily encouragement and ministry updates
            </p>
            <a
              href="https://www.youtube.com/@angelicakhesed"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: '#8B4513',
                color: 'white',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '0px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease'
              }}
            >
              Subscribe to Our YouTube Channel
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};